import PagesStack from './PagesStack';

export default PagesStack;
